export function fixBadTelemetryData<T extends { latitude: number; longitude: number }>(data: T[]) {
    let lastValid: T | undefined
    const forwardFilled = data.map((d) => {
        if (!!d.latitude && !!d.longitude) {
            lastValid = d
        } else if (lastValid) {
            return { ...d, latitude: lastValid.latitude, longitude: lastValid.longitude }
        }
        return d
    })
    lastValid = undefined
    for (let i = forwardFilled.length - 1; i >= 0; i--) {
        const d = forwardFilled[i]
        if (!!d.latitude && !!d.longitude) {
            lastValid = d
        } else if (lastValid) {
            forwardFilled[i].latitude = lastValid.latitude
            forwardFilled[i].longitude = lastValid.longitude
        }
    }
    return forwardFilled
}
